























import { Vue, Component } from 'vue-property-decorator';
import VueCookieAcceptDecline from 'vue-cookie-accept-decline';
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css';
import T from '../../lang';
@Component({
  components: {
    'vue-cookie-accept-decline': VueCookieAcceptDecline,
  },
})
export default class CookieConsent extends Vue {
  T = T;
  cookieRemovedCookie = false;
}
